/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import _chunk from 'lodash/chunk';

import { TextAlignPropType, VerticalAlignPropType } from '../../services/proptypes';
import CTA from './CTA';
import { getTextAlignClass, getVerticalAlignClass } from './utils';

import './CallToActionBanner.css';

function CallToActionBanner({ children, columns, textAlign, verticalAlign, ...extraProps }) {
  const childrenCount = children.length;
  if (childrenCount === 0) {
    return null;
  }

  const cols = Math.min(columns || childrenCount, 16);

  const rowsWithChildren = _chunk(children, cols);

  const extraClasses = [getTextAlignClass(textAlign), getVerticalAlignClass(verticalAlign)].join(
    ' ',
  );

  return (
    <Grid className={`cta-banner ${extraClasses}`} columns={cols} {...extraProps}>
      {rowsWithChildren.map((rowChildren, idx) => (
        <Grid.Row
          columns={rowChildren.length}
          key={`cta-banner-row-${idx}`}
          className="cta-banner-row"
        >
          {rowChildren}
        </Grid.Row>
      ))}
    </Grid>
  );
}

CallToActionBanner.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  columns: PropTypes.number,
  textAlign: TextAlignPropType,
  verticalAlign: VerticalAlignPropType,
};

CallToActionBanner.defaultProps = {
  columns: null,
  children: [],
  textAlign: 'center',
  verticalAlign: 'middle',
};

CallToActionBanner.CTA = CTA;

export default CallToActionBanner;
